import { t } from "../i18n";
import { mapMode } from "../state";

export function ExpandMapButton() {
  const isFull = mapMode.value === "full";
  return (
    <button
      type="button"
      class="expand-map-btn"
      onClick={() => {
        mapMode.value = isFull ? "split" : "full";
      }}
      aria-label={isFull ? t("collapse_map") : t("expand_map")}
      title={isFull ? t("collapse_map") : t("expand_map")}
    >
      {isFull ? "×" : "⛶"}
    </button>
  );
}
